// services/adminShipping.service.ts
import axiosInstance from ".";

interface UpdateShippingStatusBody {
  shippingStatus: "Pending" | "Shipped" | "In Transit" | "Delivered" | "Cancelled";
  trackingNumber?: string;
  courierService?: string;
  shippedAt?: Date;
  deliveredAt?: Date;
}

// Get all shipping records
export const getAllShippingsAPI = async () => {
  const response = await axiosInstance.get(`/admin/shippings`);
  return response;
};

// Update shipping status
export const updateShippingStatusAPI = async ({ id, body }: { id: string; body: UpdateShippingStatusBody }) => {
  const response = await axiosInstance.patch(`/admin/shippings/${id}/status`, body);
  return response;
};
